'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { Suspense } from 'react'
import EmailForm from './Forms/EmailForm'
import SessionExpiredBanner from './SessionExpiredBanner'
import Link from 'next/link'
import { authRoutes } from '@/services/auth/auth.service'
import { FacebookButton, GoogleButton } from '@/components/ui/button'

export default function Login() {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="space-y-6 text-foreground"
      >
        <Suspense fallback={null}>
          <SessionExpiredBanner />
        </Suspense>

        <div className="space-y-2">
          <div className="text-center text-2xl font-bold md:text-left ">
            Bienvenue!
          </div>
        </div>

        <EmailForm />
      </motion.div>
    </AnimatePresence>
  )
}
